
import instance from "../axios/axios.config";
const { stateFile, provision, stateFileImport } = instance;

export const getAutomationAssessmentApi = async (formData) => {
    try {
        const response = await stateFile.post(`/assessment/resources`, formData)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const downloadFileApi = async (bucketName, key, region, credentials) => {
    try {
        const response = await provision.get(`/download/get_s3_object?bucket_name=${bucketName}&key=${key}&region=${region}&credentials=${credentials}`, {
            responseType: 'blob'
        })
        return response || {}
    } catch (error) {
        console.error(error)
    }
}

export const getImportServicesApi = async () => {
    try {
        const response = await stateFileImport.get(`/import`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const importStateFileApi = async (formData) => {
    try {
        const response = await stateFileImport.post(`/import/statefile`, formData)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getRegionsByAccountApi = async (credential) => {
    try {
        const response = await stateFile.post(`/assessment/regions?cred_name=${credential}`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getVpcSubnetsByAccountApi = async (credName, region) => {
    try {
        const response = await provision.get(`/terraform/vpc-subnets?credName=${credName}&region=${region}`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAssessmentHistoryApi = async () => {
    try {
        const response = await stateFile.get(`/assessment/history`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}
